import * as React from 'react'
import { getAffiliatesTable } from '../../../Model/AffiliateModel'
import HttpActionsService from '../../../Services/HttpActionsService'
import { inject, observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import LocalizationStore from '../../../Stores/LocalizationStore'
import UserStore from '../../../Stores/UserStore'
import ExportToCsvComponent from '../../../Components/ExportToCsvComponent'
import { ExportType } from '../../../Stores/ExportStore'
import PageSizeComponent from '../../../Components/PageSizeComponent'

export interface IAffiliatesPageProps {
    httpActionsService?: HttpActionsService
    localizationStore?: LocalizationStore
    userStore?: UserStore
}

@inject('httpActionsService')
@inject('localizationStore')
@inject('userStore')
@observer
export default class AffiliatesPage extends React.Component<IAffiliatesPageProps> {

    componentDidMount() {
        this.props.httpActionsService!.getAffiliates()
    }

    render() {

        const { localizationStore, userStore } = this.props

        return (
            <div className="affiliatesPage row page">
                <div className="col-12">
                    <h4>{localizationStore!.t('AffiliatesPageHeader')}</h4>
                </div>
                <div className="col-12">
                    <PageSizeComponent />
                    <ExportToCsvComponent exportType={ExportType.Affiliates} />
                    {getAffiliatesTable()}
                </div>
                <div className="col-12" hidden={!(userStore!.checkAdmin || userStore!.checkSuperAdmin)}>
                    <Link to="/affiliate">
                        {`${localizationStore!.t('Create')} ${localizationStore!.t('Affiliate')}`}
                    </Link>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Affiliate/AffiliatesPage.tsx